/**
 * Konva 9 `Line.getSelfRect`가 tension 곡선의 캐시된 점을 쓰도록.
 *
 * 원본은 tension≠0이면 부를 때마다 `_getTensionPoints()`(캐시 안 거침)로 곡선 제어점을 새로 계산하고, 양 끝점과
 * spread로 새 배열을 만든 뒤 min/max를 구한다. 브러시 getClientRect(스냅샷 영역 누적 등)마다 Line 수만큼 큰 배열이
 * 생겨 A21s 브러시 많은 층 진입 할당의 ≈5.7MB(전체 ≈14%)였다(힙 샘플링).
 * 그리기가 쓰는 `getTensionPoints()` 캐시('tensionPoints' — Konva가 points·tension·closed 변경 때 비운다)를 그대로 돌아
 * 같은 점 집합의 min/max를 구한다(결과 동일, 브러시 438개 getClientRect 34 → 19ms).
 */
import Konva from 'konva'

interface SelfRect {
  x: number
  y: number
  width: number
  height: number
}
type LineProto = { getSelfRect(this: Konva.Line): SelfRect }

const lineProto = Konva.Line.prototype as unknown as LineProto
const original = lineProto.getSelfRect

lineProto.getSelfRect = function (this: Konva.Line): SelfRect {
  const points = this.points()
  if (points.length < 4 || this.tension() === 0) {
    return original.call(this)
  }
  // 원본 배열 = [첫 점, ...tension 점, 끝 점] — 같은 점들을 새 배열 없이 돈다
  const tp = this.getTensionPoints()
  let minX = points[0]
  let maxX = points[0]
  let minY = points[1]
  let maxY = points[1]
  for (let i = 0; i < tp.length; i += 2) {
    minX = Math.min(minX, tp[i])
    maxX = Math.max(maxX, tp[i])
    minY = Math.min(minY, tp[i + 1])
    maxY = Math.max(maxY, tp[i + 1])
  }
  const lastX = points[points.length - 2]
  const lastY = points[points.length - 1]
  minX = Math.min(minX, lastX)
  maxX = Math.max(maxX, lastX)
  minY = Math.min(minY, lastY)
  maxY = Math.max(maxY, lastY)
  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY }
}
